import {AuthContext} from '@/context/Auth/AuthContext'
import {UserRoleContext} from '@/context/UserRole/UserRoleContext'
import {UserRoleProvider} from '@/context/UserRole/UserRoleProvider'
import {Template} from '@/pages/Template'
import {useContext} from 'react'
import {Outlet} from 'react-router-dom'

export const ProtectedRoutes = () => {
  return (
    <UserRoleProvider>
      <Template>
        <ProtectedRoutesContent />
      </Template>
    </UserRoleProvider>
  )
}

const ProtectedRoutesContent = () => {
  const {isAuthenticated} = useContext(AuthContext)
  const {isAuthorized} = useContext(UserRoleContext)

  const canRenderRoute = isAuthenticated && isAuthorized
console.log('canRenderRoute',canRenderRoute);

  return canRenderRoute ? <Outlet /> : <Outlet />
}
